function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h32v32h-32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.5757576 21.0042424h-1.4424243v-20.36363634c0-.23430262-.1899398-.42424242-.4242424-.42424242h-3.5975757c-.2343027 0-.4242425.1899398-.4242425.42424242v20.36363634h-2.1721212v-9.7575757c0-.2343027-.1899398-.4242425-.4242424-.4242425h-3.5890909c-.2343026 0-.4242424.1899398-.4242424.4242425v9.7575757h-2.1551516v-16.1212121c0-.23430262-.1899398-.42424242-.4242424-.42424242h-3.58909089c-.23430262 0-.42424243.1899398-.42424243.42424242v16.1212121h-2.17212121v-13.15151513c0-.23430262-.1899398-.42424242-.42424242-.42424242h-3.59757576c-.23430262 0-.42424242.1899398-.42424242.42424242v13.15151513h-1.44242425c-.2343026 0-.42424238.1899398-.42424238.4242424 0 .2343027.18993978.4242425.42424238.4242425h27.15151518c.2343026 0 .4242424-.1899398.4242424-.4242425 0-.2343026-.1899398-.4242424-.4242424-.4242424z",
  fill: "#118623",
  fillRule: "nonzero",
  transform: "translate(2 5)"
}));

var SvgDashboardG = function SvgDashboardG(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboardG, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DashboardG.8abb6de8.svg";
export { ForwardRef as ReactComponent };